import React,{useState,useEffect,useContext} from 'react';
import PropTypes from 'prop-types';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import FormControl from '@mui/material/FormControl';
import moment from "moment";
import numeral from "numeral";
import * as utils  from "../utils";
import AuthContext from "./auth/Context";

function Field(props) {
    let { field,onChange,value,row,master,readOnly,onBlur,required,label,InputProps,inputProps,InputLabelProps,mediaQueryMatches,variant,margin, ...rest} = props;
    if(!field) field = {};

    if(readOnly && field && (field.is_title || (field.gridConfigs && field.gridConfigs.render))){
        const context = useContext(AuthContext)
        let renderContent = value;
        if(field && field.gridConfigs && field.gridConfigs.render){
          let body_func = (field.gridConfigs.render.indexOf("return ")<0?"return ":"") + field.gridConfigs.render;
          try{
            let func = new Function("row","data","master","value","style","server_url","context","moment","numeral","utils",body_func);
            renderContent = func(row||{[field.name]:value},row||{[field.name]:value},master||row||{[field.name]:value},value,{},context.config.server_url,context,moment,numeral,utils);
          }catch(e){
            console.error(e,body_func);
            renderContent = e.message;
          }
        }
        return (
            <div style={{flex:1}} class="flex-text-field">
                {!!label && !field.is_title && <Typography component="div" variant="caption" class="InputLabel" style={(InputLabelProps||{}).style}><span dangerouslySetInnerHTML={{__html: label}}/> {required && <span>*</span>} </Typography>}
                <Typography style={(InputProps||{}).style} dangerouslySetInnerHTML={{__html:renderContent}}/>
            </div>
        )
    }
    let [data,setData] = useState(value);
    useEffect(()=>{
        setData(value)
    },[value])

    if(mediaQueryMatches ){
        if(props.inline){
            return (
                <TextField
                    value={data}
                    variant="standard"
                    placeholder={label}
                    onKeyDown={event=>{
                        if(event.key === 'Enter' &&  onChange && data!=value){
                            onChange({target:{value:data}})
                        }
                    }}
                    onBlur={event=>{
                        if(onChange && data!=value){
                            onChange({target:{value:data}})
                        }
                    }}
                    onChange={(event)=>{
                        let new_value = event.target.value;
                        if(new_value!=data){
                            setData(new_value);
                        }
                    }}
                    slotProps={{
                        htmlInput:inputProps,
                        input:{
                            disableUnderline: true,
                            style:{padding:3,border:"1px solid #B9B9B9",borderRadius:3,display:"flex",flexDirection:"row",alignItems:"center",backgroundColor:readOnly?'#f5f5f5':undefined},
                            ...(InputProps||{})
                            
                        }

                    }}
                    /*inputProps={inputProps}
                    InputProps={{
                        disableUnderline: true,
                        style:{padding:3,border:"1px solid #B9B9B9",borderRadius:3,display:"flex",flexDirection:"row",alignItems:"center",backgroundColor:readOnly?'#f5f5f5':undefined},
                        ...(InputProps||{})
                        
                    }}*/
                    {...rest}
                    margin="none"
                />
            )
        }
        return (
            <div style={{flex:1}}  class="flex-text-field">
                <FormControl variant={variant} margin={margin || "normal"} fullWidth required={required}>
                    {!!label && <Typography component="div" variant="caption" class="InputLabel"  style={(InputLabelProps||{}).style}><span dangerouslySetInnerHTML={{__html: label}}/> {required && <span>*</span>}</Typography>}
                    <TextField
                        variant="standard"
                        value={data}
                        onKeyDown={event=>{
                            if(event.key === 'Enter' &&  onChange && data!=value){
                                onChange({target:{value:data}})
                            }
                        }}
                        onBlur={event=>{
                            if(onChange && data!=value){
                                onChange({target:{value:data}})
                            }
                        }}
                        onChange={(event)=>{
                            let new_value = event.target.value;
                            if(new_value!=data){
                                setData(new_value);
                            }
                        }}
                        slotProps={{
                            htmlInput:inputProps,
                            input:{
                                disableUnderline: true,
                                style:{padding:5,border:"1px solid #B9B9B9",borderRadius:3,display:"flex",flexDirection:"row",alignItems:"center",backgroundColor:readOnly?'#f5f5f5':undefined},
                                ...(InputProps||{})
                                
                            }

                        }}
                        /*inputProps={inputProps}
                        InputProps={{
                            disableUnderline: true,
                            style:{padding:5,border:"1px solid #B9B9B9",borderRadius:3,display:"flex",flexDirection:"row",alignItems:"center",backgroundColor:readOnly?'#f5f5f5':undefined},
                            ...(InputProps||{})
                            
                        }}*/
                        {...rest}
                        
                        margin="none"
                    />
                </FormControl>
            </div>
        )
    }
    return (
        <TextField
            value={data}
            onKeyDown={event=>{
                if(event.key === 'Enter' &&  onChange && data!=value){
                    onChange({target:{value:data}})
                }
            }}
            onBlur={event=>{
                if(onChange && data!=value){
                    onChange({target:{value:data}})
                }
            }}
            onChange={(event)=>{
                let new_value = event.target.value;
                if(new_value!=data){
                    setData(new_value);
                }
            }}
            /*InputLabelProps={InputLabelProps}
            inputProps={inputProps}
            InputProps={InputProps}*/
            label={label?<span  dangerouslySetInnerHTML={{__html: label}}/>:null}
            

            slotProps={{
                htmlInput:inputProps,
                input:InputProps,
                inputLabel:InputLabelProps

            }}
            
            variant ={variant}
            margin ={margin}
            required={required}
            {...rest}
        />
    );
}
Field.propTypes={
    label:PropTypes.any,
    required:PropTypes.bool,
    mediaQueryMatches:PropTypes.bool,
    value:PropTypes.any,
    row:PropTypes.row,
    master:PropTypes.master,
    onChange:PropTypes.func,
    readOnly:PropTypes.bool,
    InputProps:PropTypes.any,
    inputProps:PropTypes.any,
    InputLabelProps:PropTypes.any,
    margin:PropTypes.string,
    variant:PropTypes.string,
}
export default Field;